import { FC } from "react";
import { useTranslation } from "react-i18next";
import ImageWithEmptyFallback from "@Components/ImageWithEmptyFallback/ImageWithEmptyFallback";
import { ProgramExchangeDetailsType } from "src/Modules/PointsExchange/constants";
import { formatNumber } from "src/utility";

const ExchangeDetailsCard: FC<Pick<ProgramExchangeDetailsType, "destinationProgram" | "exchangeInfo">> = ({ destinationProgram, exchangeInfo }) => {
  const { t } = useTranslation();

  return (
    <div className="flex items-center gap-2 md:gap-4">
      <ImageWithEmptyFallback
        src={destinationProgram?.imageUrl}
        alt={destinationProgram?.name}
        className="size-20! max-w-20! md:size-28! md:max-w-28! outline-border-subtle aspect-square shrink-0 rounded-md object-cover outline"
      />
      <div className="flex flex-col gap-1">
        <span className="text-font-default text-base font-bold md:text-2xl">{destinationProgram?.name}</span>
        <span className="text-font-subtle text-sm">
          {t("PointsExchange.exchange.pointsRange")}:{" "}
          <span className="text-font-active font-semibold">
            {formatNumber(exchangeInfo?.min)} - {formatNumber(exchangeInfo?.max)} {t("PointsExchange.exchange.pointsSuffix")}
          </span>
        </span>
      </div>
    </div>
  );
};

export default ExchangeDetailsCard;
